import { flatten, map, pluck } from "ramda";
import { Maybe } from "true-myth";

import { getItemTotals } from "packages/online_ordering/helpers/item_totals";
import type { ICartItem, ICartSide } from "types/cart";
import type { ISide } from "types/menu";
import type { ICartItemSummary } from "types/totals";

interface SerializedStockLevel {
  value: number | undefined;
}

interface SerializedSide extends ICartSide {
  stockLevel: SerializedStockLevel;
}

interface SerializedCartItem
  extends Omit<ICartItem, "stockLevel" | "sides" | "selectedSides"> {
  stockLevel: SerializedStockLevel;
  sides: Array<ISide & { stockLevel: SerializedStockLevel }>;
  selectedSides: SerializedSide[];
}

export function transformCartItem(cartItem: ICartItem): ICartItemSummary {
  const { subtotal } = getItemTotals(cartItem);
  const {
    id,
    name,
    price,
    quantity,
    instructions,
    selectedModifiers,
    selectedSides,
  } = cartItem;

  return {
    itemId: id,
    name,
    price,
    quantity,
    instructions,
    total: Math.round(subtotal),
    modifiers: flatten(pluck("mods", selectedModifiers)),
    sides: selectedSides,
  };
}

export function convertStockLevelToMaybe(
  serializedCart: SerializedCartItem[]
): ICartItem[] {
  return map(item => {
    const sidesWithStocks = map(side => {
      return {
        ...side,
        stockLevel: Maybe.of(side.stockLevel.value),
      };
    }, item.sides);
    const selectedSidesWithStocks = map((side: SerializedSide) => {
      return {
        ...side,
        stockLevel: Maybe.of(side.stockLevel.value),
      };
    }, item.selectedSides);
    return {
      ...item,
      sides: sidesWithStocks,
      selectedSides: selectedSidesWithStocks,
      stockLevel: Maybe.of(item.stockLevel.value),
    };
  }, serializedCart) as ICartItem[];
}
